export default __webpack_public_path__ + "static/media/nossas_unidades_4.a90d41d3.webp";